var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-agreement"},[_c('iframe',{attrs:{"src":"/用户协议2.html","frameborder":"0","width":"100%","height":"800px"}})])
}]

export { render, staticRenderFns }